import React from "react";
import StackedAvatars from "./StackedAvatars";
import {
  AdminMainText,
  AdminMetadataText,
  AdminTableBody,
} from "../../../sections/AdminDashboard/shared/adminUx";

const ChatListItem = ({
  profileImage,
  profileName,
  lastMsg,
  timeStamp,
  onClick,
  checkBox,
  isChecked,
  onCheckboxChange,
  chatId,
  messageType,
  isGroupQuote,
  groupRecipients,
  onUserAvatarClick,
  isUnread,
  rightAction,
}) => {
  return (
    <div
      className={`flex items-center w-full py-5 px-2 hover:bg-gray-50 transition-colors duration-200 ${isGroupQuote ? "" : "cursor-pointer"}`}
      onClick={isGroupQuote ? undefined : onClick}
    >
      <div className="flex items-center gap-4 flex-shrink-0" style={{ width: "280px", minWidth: "280px" }}>
        {checkBox && (
          <label
            className="relative flex items-center rounded-full cursor-pointer flex-shrink-0"
            htmlFor={`checkbox-${chatId}`}
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              className="before:content[''] peer relative size-4 cursor-pointer appearance-none rounded-[4px] border border-mediumgray transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primaryblue checked:bg-primaryblue checked:before:bg-primaryblue"
              id={`checkbox-${chatId}`}
              checked={isChecked || false}
              onChange={(e) => onCheckboxChange && onCheckboxChange(chatId, e.target.checked)}
              onClick={(e) => e.stopPropagation()}
            />
            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 peer-checked:opacity-100">
              <i className="fi fi-rs-check text-[10px]" aria-hidden />
            </span>
          </label>
        )}
        <div className="flex items-center gap-4 flex-1 min-w-0">
          {isGroupQuote && groupRecipients && groupRecipients.length > 0 ? (
            <StackedAvatars recipients={groupRecipients} onAvatarClick={onUserAvatarClick} />
          ) : (
            <img
              src={profileImage}
              alt={profileName}
              className="size-12 rounded-full object-cover flex-shrink-0"
            />
          )}
          {!isGroupQuote && (
            <div className="flex-1 min-w-0">
              <AdminTableBody emphasis className="block truncate text-offblack">
                {profileName}
              </AdminTableBody>
            </div>
          )}
        </div>
      </div>
      <div className="flex-2 min-w-0 mx-4 text-left flex items-center gap-1.5" style={{ maxWidth: "50%" }}>
        {isUnread && (
          <span className="w-2 h-2 rounded-full bg-primaryblue flex-shrink-0 mt-0.5" aria-hidden />
        )}
        <AdminMainText className="truncate text-left flex-1 min-w-0 text-offblack">
          <span className="truncate block text-left">{lastMsg}</span>
        </AdminMainText>
      </div>
      <div
        className="flex-1 min-w-0 flex items-center justify-end gap-4 ml-4"
        onClick={(e) => rightAction && e.stopPropagation()}
      >
        <AdminMetadataText className="text-mediumgray whitespace-nowrap">{timeStamp}</AdminMetadataText>
        {rightAction}
      </div>
    </div>
  );
};

export default ChatListItem;
